import { Box, Link } from "@mui/material";
import StyledDivider from "@/src/components/common/styled-divider/styled-divider";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import NextLink from "next/link";

const ArticleMetrics = ({ comments }: { comments: Comment[] }) => (
  <Box>
    <StyledDivider label={"Comments"} />
    <Link component={NextLink} href="#comments" underline="none">
      <SpanTypography
        sx={{
          fontSize: ".875rem",
          mr: 0.25
        }}>
        </SpanTypography>
      <SpanTypography
        sx={{
          fontSize: ".875rem",
          mr: 0.25
        }}>
        Number of Comments:
      </SpanTypography>
      <SpanTypography sx={{
        fontSize: ".875rem"
      }}>{comments.length}</SpanTypography>
    </Link>
  </Box>
);

export default ArticleMetrics;
